import {
  FaInstagram,
  FaPhone,
  FaEnvelope,
  FaGithub,
  FaFacebook,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
} from 'react-icons/fa';

const socialConnect = [
  {
    name: 'Phone',
    icon: FaPhone,
    link: 'tel:+6285748783507',
  },
  {
    name: 'Email',
    icon: FaEnvelope,
    link: 'mailto:muhammadariffaizin@gmail.com',
  },
  {
    name: 'Github',
    icon: FaGithub,
    link: 'https://github.com/MuhammadArifFaizin',
  },
  {
    name: 'LinkedIn',
    icon: FaLinkedin,
    link: 'https://linkedin.com/in/muhammad-arif-faizin/',
  },
  {
    name: 'Instagram',
    icon: FaInstagram,
    link: 'https://instagram.com/m.arif.faizin/',
  },
  {
    name: 'Facebook',
    icon: FaFacebook,
    link: 'https://facebook.com/muhammad.arif.faizin.19',
  },
  {
    name: 'Twitter',
    icon: FaTwitter,
    link: 'https://twitter.com/m_ariffaizin',
  },
  {
    name: 'Youtube',
    icon: FaYoutube,
    link: 'https://youtube.com/channel/UCARbCm0OoRSJyICep9XTZAQ',
  },
];

export default function Footer() {
  return (
    <footer className='py-4'>
      <p>You can reach me on</p>
      <div className='flex justify-center text-center'>
        {socialConnect.map((social) => (
          <a key={social.name} href={social.link} target='blank'>
            <social.icon className='m-2 text-xl' />
          </a>
        ))}
      </div>
    </footer>
  );
}
